import { render, staticRenderFns } from "./ChoooseRegistrationForm.vue?vue&type=template&id=33d29ef8&scoped=true&"
var script = {}
import style0 from "./ChoooseRegistrationForm.vue?vue&type=style&index=0&id=33d29ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d29ef8",
  null
  
)

export default component.exports